import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import Destination from "../destination/Destination";
import Shop from "../shop/Shop";
import Home from "./Home";
function Header() {
  return (
    <>
      <div className="main">
        <video
          src="https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2019/07/hero-video.mp4"
          className="object-fit-cover"
          id="myVideo"
          playsinline
          autoPlay
          muted
          loop
        />
      <div className="down text-center position-absolute">
        <h1 className="text-light">Make Your Life Extraordinary!</h1>
        <button type="button" class="btn btn-lg mt-5 px-5 py-3 findbtn">
          Find Destination
        </button>
      </div>
      <div className="container ">
        <nav className="navbar navbar-expand-lg bg-body-tertiary pop">
          <div className="container ">
            <Link className="navbar-brand" to="/">
              <img width={140} src={require("../image/logo-dark.png")} />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-lg-auto">
                <li className="nav-item dropdown nav1 me-3">
                  <a
                    className="nav-link dropdown-togglehome"
                    href="/"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Home
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Travel Agency
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Summer Holiday
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Destination Showcase
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        City Tours
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Tour Classic
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Tour Package
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown nav1 me-3">
                  <Link
                    className="nav-link dropdown-toggle home"
                    to="/destination"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Destination
                  </Link>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Most Popular
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Popular in Europe
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Destination for Group
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown nav1 me-3">
                  <a
                    className="nav-link dropdown-toggle home"
                    href="/shop"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Shop
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Single Product
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Variation Product
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Popular T-Shirt
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Premium Quality
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown nav1 me-3">
                  <Link
                    className="nav-link dropdown-toggle home"
                    to="/"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Region
                  </Link>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Switzerland
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Oceania
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Africa
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item py-2 px-4" href="#">
                        Canada
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown position-static nav1 me-2">
                  <Link
                    className="nav-link home"
                    to="/"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Blog
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/destination" element={<Destination />} />
        <Route path="/shop" element={<Shop />} />
      </Routes>
    </>
  );
}

export default Header;
